<template>
  <div id="contenedor-listado-expedientes-catalogo-documentos-mobiles">
    <template
      v-for="(expedienteDocumento, index) in listadoExpedienteCatalogoDocumentos">
      <v-card
        :key="index"
        class="mb-2">
        <v-card-title
          class="justify-space-between">
          <div
            class="d-inline-block text-truncate">
            {{ expedienteDocumento.descripcion }}
          </div>
        </v-card-title>
        <v-card-text>
            {{ expedienteDocumento.descripcion }}
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>

export default {
  name: 'ListadoExpedientesCatalogoDocumentosMobiles',
  props: {
    listadoExpedienteCatalogoDocumentos: {
      type: Array,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
